import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from '../home/home.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { NotAuthGuard } from './guards/not-auth/not-auth.guard';
import { RoleGuard } from './guards/role/role.guard';
import { AuthComponent } from './pages/auth/auth.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { UserComponent } from '../user/user.component';
import { ExamplePageComponent } from '../shared/example-page/example-page.component';
import { ApiRequestsComponent } from '../api-requests/api-requests.component';
import { ApiEndpointsDescComponent } from '../api-endpoints-desc/api-endpoints-desc.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AuthComponent, canActivate: [NotAuthGuard] },
  { path: 'example-page', component: ExamplePageComponent, canActivate: [AuthGuard] },
  {
    path: 'newUserConfirmation',
    loadChildren: () =>
      import('../new-user-confirmation/new-user-confirmation.module').then(
        (m) => m.NewUserConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },
  {
    path: 'emailConfirmation',
    loadChildren: () =>
      import('../email-confirmation/email-confirmation.module').then(
        (m) => m.EmailConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },
  {
    path: 'home',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'api-requests',
    loadChildren: () => import('../api-requests/api-requests.module').then((m) => m.ApiRequestsModule),
    component: ApiRequestsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Admin', 'ApiRequester'] },
  },
  {
    path: 'api-endpoints-documentation',
    loadChildren: () => import('../api-endpoints-desc/api-endpoints-desc.module').then((m) => m.ApiEndpointsDescModule),
    component: ApiEndpointsDescComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Admin', 'ApiRequester'] },
  },
  {
    path: 'user',
    loadChildren: () => import('../user/user.module').then((m) => m.UserModule),
    component: UserComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ['Admin', 'CustomersAdmins'] },
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('../contact/contact.module').then((m) => m.ContactModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '*',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class CoreRoutingModule { }
